/**
 * Created by evgeny on 13.06.2024
 */

const Map2dEditor = function (location, GameOrangery) {
    this.locationId = location.locationId;

    EditorBase.call(this);

    const url = bundles[location.locationConfig.locationBundleId].jsons.map_json.resolve();
    const levelContent = url.getJson();

    this.editorClient = new EditorClient(this);
    this.editorClient.connect();
    this.editorClient.open(url.originalPath(), levelContent.commandUid, (commandUid) => {
        this.map.commandUid = commandUid;
        this.map.saveLevel();
    });

    this.GameOrangery = GameOrangery;

    const mapAdapter = cleverapps.dataSlots.getSlot("fake");

    this.map = Map2d.currentMap = new EditorMap2d(mapAdapter, levelContent.map, {
        tiles: levelContent.tiles,
        units: levelContent.units,
        visibleBox: levelContent.visibleBox,
        regions: levelContent.regions,
        decorators: levelContent.decorators,
        terrains: levelContent.terrains,
        field: levelContent.field,
        families: location.families,
        reference: levelContent.reference,
        background: levelContent.background,

        commandUid: levelContent.commandUid
    });
    this.map.scroller = new Map2dScroller(this.map);

    this.layers = Map2dEditor.LAYERS.filter((entry) => {
        if (entry.id === Map2dEditor.LAYER_BACKGROUND) {
            return Boolean(this.map.getBackgroundBundle());
        }
        return true;
    });

    Map2d.InsertDefaults(this.map, levelContent.field);

    this.regions = new RegionsUnits();
    this.decorators = new DecoratorUnits();

    this.brushed = {};
    this.commandCounts = {};

    this.orangery = new Orangery(GameOrangery);

    this.orangery.on("selectionChanged", this.select.bind(this));
    this.orangery.on("selectionChanged", this.cleanupBrushedArea.bind(this));
    this.orangery.on("toggleBrushMode", this.cleanupBrushedArea.bind(this));

    this.onChangeLayer = function () {};
    this.setLayer(Map2dEditor.LAYER_UNITS);

    this.editorPointers = new EditorPointers(this.editorClient);
    this.editorPointers.startTracking();
};

Map2dEditor.prototype = Object.create(EditorBase.prototype);
Map2dEditor.prototype.constructor = Map2dEditor;

Map2dEditor.prototype.destructor = function () {
    this.editorPointers.destructor();
    this.editorClient.destructor();

    EditorBase.prototype.destructor.call(this);
};

Map2dEditor.prototype.doCommand = function (type, data) {
    this.commandCounts[type] = (this.commandCounts[type] || 0) + 1;
    this.editorClient.doCommand(type, data);
};

Map2dEditor.prototype.getTopCommand = function () {
    return Object.keys(this.commandCounts).sort((a, b) => this.commandCounts[b] - this.commandCounts[a])[0];
};

Map2dEditor.prototype.beginBatch = function () {
    this.editorClient.beginBatch();
};

Map2dEditor.prototype.endBatch = function () {
    this.editorClient.endBatch();
};

Map2dEditor.prototype._load = function () {
};

Map2dEditor.prototype.setLayer = function (layer) {
    this.unselect();

    this.layer = layer;

    this.trigger("changeLayer", layer);
};

Map2dEditor.prototype.setLayerVisible = function (layer, visible) {
    if (layer === Map2dEditor.LAYER_UNITS) {
        Map2d.setUnitsVisible(visible);
    }
    if (layer === Map2dEditor.LAYER_DECORATORS) {
        Map2d.setDecoratorsVisible(visible);
    }
    if (layer === Map2dEditor.LAYER_GROUND) {
        Map2d.setGroundVisible(visible);
    }
    if (layer === Map2dEditor.LAYER_BACKGROUND) {
        Map2d.setBackgroundVisible(visible);
    }

    this.trigger("changeLayerVisibility", layer, visible);
};

Map2dEditor.prototype.setBoundsMode = function (active) {
    this.boundsMode = Boolean(active);

    this.trigger("changeBoundsMode", this.boundsMode);
};

Map2dEditor.prototype.cleanupBrushedArea = function () {
    this.brushed = {};
};

Map2dEditor.prototype.produce = function (x, y, selected, shift) {
    if (!this.map.isValid(x, y)) {
        return false;
    }

    selected = selected || this.selected;
    if (selected === undefined) {
        return false;
    }

    this.beginBatch();

    if (shift) {
        this.produceSingle(x, y, selected, shift);
    } else if (this.orangery.isBrushMode()) {
        this.orangery.getBrushShape().forEach((offset) => {
            const cell = {
                x: x + offset.x,
                y: y + offset.y
            };

            if (this.brushed[`${cell.x}_${cell.y}`]) {
                return;
            }

            this.brushed[`${cell.x}_${cell.y}`] = true;

            if (selected.decorator) {
                if (Math.random() <= 0.35) {
                    this.produceSingle(x + offset.x, y + offset.y, selected);
                }
            } else {
                this.produceSingle(x + offset.x, y + offset.y, selected);
            }
        });
    } else {
        this.produceSingle(x, y, selected);
    }

    this.endBatch();

    return true;
};

Map2dEditor.prototype.produceSingle = function (x, y, selected, shift) {
    if (!this.map.isValid(x, y)) {
        return;
    }

    this.lastProducedDecorator = undefined;

    if (selected.eraser) {
        if (selected.id === this.GameOrangery.REGION_ID) {
            const fogTile = this.map.getFog(x, y);
            const selectedFog = this.map.fogs.selected;
            const code = selectedFog ? selectedFog.code : fogTile && fogTile.fogBlock && fogTile.fogBlock.id;

            if (code && (!fogTile || !fogTile.fogBlock || fogTile.fogBlock.id === code)) {
                const brushMode = selectedFog && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.b);
                if (brushMode) {
                    this.doCommand("clearRegion", { code });
                } else {
                    this.doCommand("removeFogTile", { x, y, code });
                }
            }
        } else if (selected.id === this.GameOrangery.DECORATOR_ID) {
            // do nothing
        } else {
            const unit = this.map.getUnit(x, y);
            if (unit && !unit.head) {
                this.doCommand("deleteUnit", { x, y, hash: unit.getUnitHash() });
            }
        }
    } else if (selected.decorator) {
        this.doCommand("produceDecorator", {
            x, y, code: selected.code
        });
        if (this.lastProducedDecorator && this.lastProducedDecorator.getView()) {
            cleverapps.sceneDebugger.selectNode(this.lastProducedDecorator.getView());
        }
    } else if (selected.region) {
        const tile = this.map.getFog(x, y);
        const code = tile && tile.fogBlock && tile.fogBlock.id;

        if (this.orangery.isBrushMode() && code === selected.code) {
            return;
        }

        // fog99 is a debug cover meant to overlay real fog, so it coexists instead of replacing
        if (tile && this.map.fogs.isFogRegion(selected.code) && this.map.fogs.isFogRegion(code)
            && selected.code !== "fog99" && code !== "fog99") {
            this.doCommand("removeFogTile", {
                x, y, code: tile.fogBlock.id
            });
        }

        if (!tile || code !== selected.code) {
            this.doCommand("produceFogTile", { x, y, code: selected.code });
        }
    } else if (selected.code) {
        if (this.map.isGround(x, y) || this.map.isWaterUnit(x, y)) {
            const unitData = {
                code: selected.code,
                stage: selected.stage
            };

            const data = Families[unitData.code].units[unitData.stage];

            if (data.source || data.grounded || unitData.grounded) {
                unitData.grounded = true;
            }

            if (shift) {
                unitData.shiftX = shift.x;
                unitData.shiftY = shift.y;
            }

            if (this.map.getUnits(x, y).filter((u) => u.findComponent(Multiple)).length >= Multiple.MAX_PER_CELL) {
                return;
            }

            this.doCommand("produceUnit", { unit: unitData, x, y });
            const fakeEntry = (this.map.fogs.fakeUnits[x] || {})[y];
            if (Array.isArray(fakeEntry) && fakeEntry.length > 1) {
                const simulated = fakeEntry.map((f) => ({ shiftX: f.shiftX || 0, shiftY: f.shiftY || 0 }));
                EditorMap2d.calcRepulsion(simulated);
                const cellUnits = this.map.getUnits(x, y).filter((u) => u.findComponent(Multiple));
                simulated.forEach((sim, i) => {
                    if (sim.shiftX !== (fakeEntry[i].shiftX || 0) || sim.shiftY !== (fakeEntry[i].shiftY || 0)) {
                        const cellUnit = cellUnits.find((u) => u.findComponent(Multiple).indexInCell === i);
                        if (cellUnit) {
                            this.doCommand("shiftMultiple", {
                                x,
                                y,
                                index: i,
                                code: cellUnit.code,
                                stage: cellUnit.stage,
                                shiftX: sim.shiftX,
                                shiftY: sim.shiftY
                            });
                        }
                    }
                });
            }
        }
    } else {
        this.doCommand("produceMap", {
            tile: selected.tile, terrain: selected.terrain, x, y
        });
    }
};

Map2dEditor.prototype.select = function (selected) {
    if (this.selected !== selected) {
        this.nextSelected = selected;
        this.unselect();

        if (selected) {
            this.selected = selected;

            if (selected.decorator) {
                selected.onUpdate();
            } else if (selected.region) {
                selected.onUpdate();
                this.map.fogs.select(selected);
            }
        }
    }
};

Map2dEditor.prototype.unselect = function () {
    if (this.selected) {
        const selected = this.selected;
        this.selected = undefined;

        if (selected.eraser && selected.id === this.GameOrangery.REGION_ID) {
            if (this.nextSelected) {
                this.map.fogs.unselect(this.map.fogs.selected);
            }
            Editor.currentEditor.orangery.select(this.nextSelected || this.map.fogs.selected);
            return;
        }

        if (selected) {
            if (selected.decorator) {
                selected.onUpdate();
            } else if (selected.region) {
                if (Editor.currentEditor.orangery.selected && Editor.currentEditor.orangery.selected.eraser) {
                    return;
                }
                selected.onUpdate();
                this.map.fogs.unselect(selected);
            } else {
                const orangery = Editor.currentEditor.orangery;
                orangery.unselect(selected);
            }
        }
    }
};

if (typeof Editor === "undefined") {
    Editor = Map2dEditor;
}

Map2dEditor.BUNDLES = ["merge", "admin", "episode_editor"];

Map2dEditor.LAYER_BACKGROUND = 0;
Map2dEditor.LAYER_GROUND = 1;
Map2dEditor.LAYER_DECORATORS = 2;
Map2dEditor.LAYER_UNITS = 3;

Map2dEditor.LAYERS = [
    { id: Map2dEditor.LAYER_BACKGROUND, text: "background" },
    { id: Map2dEditor.LAYER_GROUND, text: "ground" },
    { id: Map2dEditor.LAYER_DECORATORS, text: "decorators" },
    { id: Map2dEditor.LAYER_UNITS, text: "units" }
];

EditorClient.registerCommand("deleteUnit", {
    execute: function (editor, command) {
        const unit = command.index !== undefined
            ? editor.map.getUnits(command.x, command.y).find((u) => {
                const m = u.findComponent(Multiple);
                return m && m.indexInCell === command.index;
            })
            : EditorMap2d.findUnit(editor.map, command.x, command.y, command.hash);
        const unitData = unit && EditorMap2d.getUnitData(unit);
        if (unit) {
            command.code = unit.code;
            command.stage = unit.stage;
            const view = unit.onGetView();
            if (view) {
                view.replaceParentSamePlace(Map2d.currentMap.getMapView().animations);
                unit.view = undefined;
            }
            unit.unhighlight();
            if (unit.findComponent(Multiple)) {
                EditorMap2d.removeMultipleUnit(editor.map, unit);
            } else {
                unit.remove();
            }
            if (view) {
                view.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.2, 0).easing(cc.easeIn(2)),
                    new cc.RemoveSelf()
                ));
                cleverapps.effects.fire("merge.unit.destroy");
            }
        }
        Map2d.updateMap();
        editor.map.saveLevel();
        return { type: "produceUnit", data: { x: command.x, y: command.y, unit: unitData } };
    }
});

EditorClient.registerCommand("changeMapSize", {
    execute: (editor, command) => {
        const newSize = command.newSize;
        const content = LevelManager.getInstance().level.content;
        const prevSize = content.map[0].length;
        const oldMap = content.map;
        const dx = Math.floor((newSize - oldMap[0].length) / 2) + (command.dx || 0);
        const dy = Math.floor((newSize - oldMap.length) / 2) + (command.dy || 0);

        const map = [];
        const terrains = [];
        for (let y = 0; y < newSize; y++) {
            map.push("");
            terrains.push("");
            for (let x = 0; x < newSize; x++) {
                map[y] += oldMap[y - dy] && oldMap[y - dy][x - dx] || "0";
                terrains[y] += content.terrains[y - dy] && content.terrains[y - dy][x - dx] || ".";
            }
        }

        content.map = map;
        content.terrains = terrains;

        [...content.field, ...content.decorators].forEach((item) => {
            item.x += dx;
            item.y += dy;
        });

        Object.values(content.regions).forEach((region) => {
            region.positions.forEach((position) => {
                position.x += dx;
                position.y += dy;
            });
            if (region.head) {
                region.head.x += dx;
                region.head.y += dy;
            }
        });

        LevelManager.getInstance().update(content);
        LevelManager.getInstance().save();

        cleverapps.effects.fire("merge.spawn.landing");

        return { type: "changeMapSize", data: { newSize: prevSize, dx: -(command.dx || 0), dy: -(command.dy || 0) } };
    }
});

EditorClient.registerCommand("toggleLock", {
    execute: function (editor, command) {
        const unit = EditorMap2d.findUnit(editor.map, command.x, command.y, command.hash);
        if (unit) {
            command.code = unit.code;
            command.stage = unit.stage;
            const locked = unit.findComponent(LockedComponent);
            if (locked) {
                locked.setLockActive(!locked.isLockActive());
                editor.map.saveLevel();

                cleverapps.effects.fire(locked.isLockActive() ? "merge.unitlock.start" : "merge.unitlock.open");

                return { type: "toggleLock", data: { x: command.x, y: command.y, hash: command.hash } };
            }
        }
    }
});

EditorClient.registerCommand("shiftMultiple", {
    execute: function (editor, command) {
        const unit = editor.map.getUnits(command.x, command.y).find((u) => {
            const m = u.findComponent(Multiple);
            return m && m.indexInCell === command.index && u.code === command.code && u.stage === command.stage;
        });
        const fakeUnit = editor.map.fogs.getFakeUnits(command.x, command.y)[command.index];
        if (!unit || !fakeUnit) {
            return { type: "shiftMultiple", data: command };
        }
        const prevShiftX = fakeUnit.shiftX || 0;
        const prevShiftY = fakeUnit.shiftY || 0;
        fakeUnit.shiftX = command.shiftX || undefined;
        fakeUnit.shiftY = command.shiftY || undefined;
        unit.onApplyShift();
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.drag.start");

        return {
            type: "shiftMultiple",
            data: {
                x: command.x,
                y: command.y,
                index: command.index,
                code: command.code,
                stage: command.stage,
                shiftX: prevShiftX,
                shiftY: prevShiftY
            }
        };
    }
});